var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { class: [_vm.item.IsActive ? "active" : "", _vm.item.CustomClass] },
    [
      _c("a", { attrs: { href: _vm.item.Url } }, [
        _vm._v(_vm._s(_vm.item.Label))
      ]),
      _vm._v(" "),
      _vm.item.HasChildren
        ? _c(
            "ul",
            { staticClass: "side-menu-submenu" },
            _vm._l(_vm.item.Children, function(item, index) {
              return _c("menu-item", { key: index, attrs: { item: item } })
            }),
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }